import { useMemo, useState } from 'react';
import { Box, IconButton, Tab, Tabs } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment';
import 'moment/locale/pt-br';

const TAB_COUNT = 7;

const formatTabDate = (date) => {
  const formatted = moment(date).locale('pt-br').format('ddd, D [de] MMMM [de] YYYY');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const BookReleasesDateTabs = ({ initialDate, onDateChange }) => {
  const [windowStart, setWindowStart] = useState(() => (
    initialDate ? moment(initialDate).startOf('day') : moment().startOf('day')
  ));
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [pickerOpen, setPickerOpen] = useState(false);

  const dates = useMemo(
    () => Array.from({ length: TAB_COUNT }, (_, i) => moment(windowStart).add(i, 'days')),
    [windowStart]
  );

  const shiftWindow = (days) => {
    setWindowStart((prev) => moment(prev).add(days, 'days'));
  };

  const handleChange = (_, newIndex) => {
    setSelectedIndex(newIndex);
    if (onDateChange) {
      onDateChange(dates[newIndex]);
    }
  };

  const handlePickerChange = (newDate) => {
    if (!newDate || !moment(newDate).isValid()) {
      return;
    }
    const normalized = moment(newDate).startOf('day');
    setWindowStart(normalized);
    setSelectedIndex(0);
    if (onDateChange) {
      onDateChange(normalized);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', borderBottom: 1, borderColor: 'divider' }}>
      <IconButton onClick={() => shiftWindow(-1)} aria-label='Dia anterior'>
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Tabs
        value={selectedIndex}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons={false}
        sx={{ flexGrow: 1 }}
      >
        {dates.map((date, index) => (
          <Tab key={date.format('YYYY-MM-DD')} label={formatTabDate(date)} value={index} />
        ))}
      </Tabs>
      <IconButton onClick={() => shiftWindow(1)} aria-label='Próximo dia'>
        <KeyboardArrowRightIcon />
      </IconButton>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopDatePicker
          open={pickerOpen}
          onOpen={() => setPickerOpen(true)}
          onClose={() => setPickerOpen(false)}
          value={dates[selectedIndex]}
          onChange={handlePickerChange}
          componentsProps={{
            actionBar: { actions: ['today'] }
          }}
          renderInput={({ inputRef }) => (
            <IconButton ref={inputRef} onClick={() => setPickerOpen(true)} aria-label='Selecionar data'>
              <CalendarTodayIcon />
            </IconButton>
          )}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default BookReleasesDateTabs;